<!-- <div class="base-layout">
    <app-header></app-header>
    <main class="main-content">
        <router-outlet></router-outlet>
    </main>
</div> -->
<router-outlet></router-outlet>